export const APP_ID = 'web-registration-hello'
export const PARTNER_PAYLOAD_STORAGE_KEY = 'PARTNER_PAYLOAD'
export const REFERRAL_PAYLOAD_STORAGE_KEY = 'REFERRAL_PAYLOAD'
export const USER_UUID = 'USER_UUID'
export const USER_EMAIL = 'USER_EMAIL'
export const START_INVESTMENT_STORAGE_KEY = 'START_INVESTMENT_USER_SELECTION'
export const VISITOR_ID_KEY = 'VISITOR_ID'
export const REDIRECTION_URL_KEY = 'REDIRECTION_URL'
export const ACORNS_HELLO_FLOW = 'ACORNS_HELLO_FLOW'
export const APP_STORE_URL =
  'https://itunes.apple.com/us/app/acorns-invest-spare-change/id883324671'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.acorns.android'
export const OPTIMIZELY_VARIATIONS = 'OPTIMIZELY_VARIATIONS'
export const OPTIMIZELY_FORCED_VARIATIONS = 'FORCED_VARIATIONS'
export const OPTIMIZELY_REMOTE_STRINGS = 'REMOTE_STRINGS'
export const OPTIMIZELY_FEATURE_FLAGS = 'FEATURE_FLAGS'
export const IS_RESUME_FLOW = 'IS_RESUME_FLOW'
export const EMAIL_FROM_MARKETING_SITE = 'EMAIL_FROM_MARKETING_SITE'
export const DONT_SEE_YOUR_BANK = 'DONT_SEE_YOUR_BANK'
export const VISITED_PAGES = 'VISITED_PAGES'
export const DISABLE_EXPERIMENTS = 'DISABLE_EXPERIMENTS'
export const TIER_PRICE_ID = 'TIER_PRICE_ID'
export const TIER_PRICE = 'TIER_PRICE'
export const TIER_NAME = 'TIER_NAME'
export const TIER_KEY = 'TIER_KEY'
export const FORCE_DEFAULT_SUCCESS = 'force_default_success'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const ACORNS_DISCLOSURES_URL = 'https://www.acorns.com/disclosures/'
export const USER_TYPE = 'USER_TYPE'
export const OPTIMIZELY_CONTROL_EXPERIMENT = 'Control'
export const OPTIMIZELY_EXPERIMENT_VARIATION_1 = 'V1'
export const OPTIMIZELY_EXPERIMENT_VARIATION_2 = 'V2'
export const CURRENT_SIGN_UP_SCREEN_KEY = 'CURRENT_SIGN_UP_SCREEN'

export const MOC_ONBOARDING_FLOW = 'mightyOakCardOnboarding'
export const TIERED_FLOW = 'tiered'
export const APP_VERSION = process.env.RELEASE_TAG?.toString().trim() || ''
